import React, { useState } from "react";
import { Modal, Button, Table } from "antd";
import CardOdcModalHolder from "../../styles/cardOdcModalStyle";

const PaymentOdcModal = ({ data, t }) => {
  const [visible, setVisible] = useState(false);

  const columns = [
    {
      title: t("File"),
      dataIndex: "file",
      render: (text, record) => (
        <a className="link" href={record.file} target="_blank" rel="noopener noreferrer">
          {t("view")}
        </a>
      ),
    },
    {
      title: t("Date creation"),
      dataIndex: "created_at",
    },
  ];

  return (
    <>
      <Button shape="circle" icon="file-text" onClick={() => setVisible(true)} title={t("ODC")} />
      <Modal
        title={t("Purchase orders")}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <Button key="ok" onClick={() => setVisible(false)}>
            OK
          </Button>,
        ]}
      >
        <CardOdcModalHolder>
          {data && data.length > 0 ? (
            <div className="contentTable" style={{ paddingRight: "5%" }}>
              <Table columns={columns} dataSource={data} pagination={false} size="small" rowKey="id" />
            </div>
          ) : (
            <p className="contentTable textContent">
              {t("There are no purchase orders uploaded")}
            </p>
          )}
        </CardOdcModalHolder>
      </Modal>
    </>
  );
};

export default PaymentOdcModal;
